// Sub Routes
import employeeRoutes from '../../Employee/router';
import departmentRoutes from '../../Department/router';
//import settingsRoute from '../router';

// Components
const Index = () => import('../index.vue');
const View = () => import('../view.vue');
const General = () => import('@/modules/Settings/components/General.vue');

let settingView = [
  {
    path: '',
    name: 'settings-index',
    component: View,
    title: 'Settings',
  },
  {
    path: 'general',
    name: 'general-setting',
    component: General,
    title: 'General',
  },
]

let routes = [];
routes = routes.concat(employeeRoutes);
routes = routes.concat(departmentRoutes);
routes = routes.concat(settingView);


export default [
    {
      path: 'settings',
      name: 'settings',
      meta: { requiresAuth: true },
      redirect: { name: 'settings-index'},
      component: Index,
      children: routes,
      // beforeEnter: ((to, from, next) => {
      //   if (!localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}Hometoken`)) {
      //     next({
      //       path: 'login',
      //     })
      //   } else {
      //     next() // make sure to always call next()!
      //   }
      // })
    },
  ];